import { API_CONFIG } from '../config/api';
import { ApiResponse, LoginForm, LoginResponseData, SendCodeRequest } from '../types';
import { http, buildUrl } from './base';

/**
 * 认证相关 API 服务
 */
export class AuthService {
  /**
   * 获取验证码
   * @param phoneNumber 手机号
   * @param type 验证码类型
   */
  static async getCaptcha(
    phoneNumber: string, 
    type: 'image' | 'math' = 'image'
  ): Promise<ApiResponse<{
    captchaId: string;
    svgData: string;
    expiresAt: string;
    type: 'image' | 'math';
  }>> {
    const url = buildUrl(API_CONFIG.ENDPOINTS.AUTH.CAPTCHA);
    return http.get(url, { phoneNumber, type });
  }

  /**
   * 发送短信验证码
   * @param data 发送验证码请求数据
   */
  static async sendVerificationCode(data: SendCodeRequest): Promise<ApiResponse> {
    const url = buildUrl(API_CONFIG.ENDPOINTS.AUTH.SEND_CODE);
    return http.post(url, data);
  }

  /**
   * 用户登录
   * @param formData 登录表单数据
   */
  static async login(formData: LoginForm): Promise<ApiResponse<LoginResponseData>> {
    const url = buildUrl(API_CONFIG.ENDPOINTS.AUTH.LOGIN);
    return http.post(url, formData);
  }

  /**
   * 用户登出
   */
  static async logout(): Promise<ApiResponse> {
    const url = buildUrl(API_CONFIG.ENDPOINTS.AUTH.LOGOUT);
    return http.post(url);
  }

  /**
   * 验证 token / 获取用户信息
   */
  static async verifyToken(): Promise<ApiResponse> {
    const url = buildUrl(API_CONFIG.ENDPOINTS.AUTH.VERIFY_TOKEN);
    return http.get(url);
  }

}

export default AuthService;
